import React from "react";
/** Editor context is meant to pass on editor control state to the child elements
*/
interface PageContextProps {
  dummy?: boolean;
}

export const PageContext = React.createContext<PageContextProps>({});
